import type { ImpactRow } from './deactivate-impact';

const TONE_CLASS: Record<ImpactRow['tone'], string> = {
  warn: 'bg-clay-100 text-clay-600 dark:bg-clay-900/30 dark:text-clay-300',
  info: 'bg-[#eff8ff] text-[#1d64d7] dark:bg-water-900/30 dark:text-water-200',
  ok: 'bg-moss-50 text-moss-700 dark:bg-moss-900/30 dark:text-moss-200',
};

export default function DeactivateImpactCard({ rows }: { rows: ImpactRow[] }) {
  if (!rows.length) {
    return (
      <div className="p-3.5 rounded-lg bg-stone-50 dark:bg-[#1e2520] border border-stone-200 dark:border-stone-800 text-[12px] text-stone-600 dark:text-stone-400">
        No outstanding assignments — safe to deactivate.
      </div>
    );
  }
  return (
    <div className="p-3.5 rounded-lg bg-stone-50 dark:bg-[#1e2520] border border-stone-200 dark:border-stone-800">
      <div className="text-[10px] font-semibold tracking-[.08em] uppercase text-stone-500 dark:text-stone-400 mb-2.5">
        Currently owns
      </div>
      <div className="flex flex-col gap-2">
        {rows.map((row) => {
          const Icon = row.icon;
          return (
            <div
              key={row.label}
              className="flex items-center gap-3 px-3 py-2.5 bg-white dark:bg-[#1a1f1c] rounded-lg border border-stone-200 dark:border-stone-800"
            >
              <div
                className={`w-7 h-7 rounded-md flex items-center justify-center flex-none ${TONE_CLASS[row.tone]}`}
              >
                <Icon size={14} />
              </div>
              <div className="flex-1 min-w-0">
                <div
                  className={`text-[13px] ${row.strong ? 'font-bold text-clay-700 dark:text-clay-300' : 'font-semibold text-bark-900 dark:text-[#e8ece9]'}`}
                >
                  {row.label}
                </div>
                <div className="text-[11px] text-stone-500 dark:text-stone-400">{row.detail}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
